// Live list of approved featured submissions for the Style page strip.
// Uses a SECURITY DEFINER RPC so we only expose safe display columns
// (no source_image_path, reviewer info, or reject reasons leak to other users).
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface FeaturedItem {
  id: string;
  user_id: string;
  kind: "vibe" | "look" | "item";
  template_id: string;
  template_label: string | null;
  caption: string | null;
  permanent_image_path: string;
  display_order: number;
  created_at: string;
}

export function useFeaturedSubmissions(enabled = true) {
  const [items, setItems] = useState<FeaturedItem[]>([]);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    supabase
      .rpc("list_featured_approved", { _limit: 40 })
      .then(({ data }) => {
        if (!active) return;
        setItems((data ?? []) as FeaturedItem[]);
        setLoading(false);
      });
    return () => { active = false; };
  }, [enabled]);

  return { items, loading };
}
